import React from 'react';
import S from '../../UmbracoForm.styles';
const CheckBox = React.forwardRef(({ field, dirty, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid', "data-dirty": dirty, "data-invalid": !!error, style: { '--inputHeight': '20px' } },
        React.createElement(S.ControlLabel, { htmlFor: field.alias },
            React.createElement("input", { ref: ref, id: field.alias, type: "checkbox", required: field.required, ...otherProps }),
            React.createElement(S.CheckboxLabel, null,
                field.caption,
                " ",
                React.createElement(S.MandatoryIndicator, null, otherProps.indicator),
                " ")),
        error && React.createElement(S.Error, null, error.message)));
});
CheckBox.displayName = 'CheckBox';
export default CheckBox;
